// Lib
import React, { ReactElement } from 'react';

// Hooks
import useSheet from '../../../structural/sheet/hooks/useSheet';

// Components
import LoadableMobileSearchSheet from './LoadableMobileSearchSheet';
import Icon from '../../../../components/icons/Icon';
import Button from '../../../../components/buttons/Button';

// Types
import { SheetId } from '../../../structural/sheet/sheetTypes';

const MobileSearchTool = (): ReactElement => {
    const sheetProps = useSheet(SheetId.SearchTool);
    const { dispatchOpenSheet } = sheetProps;

    return (
        <>
            <Button className="MobileSearchTool mobile-util-button" onClick={dispatchOpenSheet}>
                <Icon name="mobile-toolbar-search" />
                <div className="label">Search</div>
            </Button>
            <LoadableMobileSearchSheet sheetProps={sheetProps} />
        </>
    );
};

export default MobileSearchTool;
